<template>
    <div class="container mt-3">

        <az-loading v-if="!pronto" />

        <template v-else>

            <div class="text-center my-3" v-if="info">
                <img :src="info.logo" alt="logo" class="logo-responsive img-fluid" style="max-height: 200px;" v-if="info.logo" />
                <h3 v-else>{{ info.nome }}</h3>
            </div>

            <div class="alert alert-danger" v-if="msg">{{ msg }}</div>

            <template v-if="info">

                <div class="text-center small text-muted" v-if="info.r && info.r.st_nome">
                    {{ info.r.st_nome }}
                </div>

                <div class="list-group mb-3" v-if="info.r && info.r.adicoes">
                    <template v-for="(adicao, iax) in info.r.adicoes">
                        <button type="button" class="list-group-item list-group-item-action" 
                            :disabled="info.r.adicoes.length == 1"
                            v-show="!sel_adicao || sel_adicao == adicao.id_recepcao_adicao"
                            :class="sel_adicao == adicao.id_recepcao_adicao ? 'active' : ''"
                            :key="iax" @click="selecionar_adicao(adicao)">
                            {{ adicao.st_titulo }}
                        </button>
                    </template>
                </div>

                <template v-if="sel_adicao">

                    <template v-if="informar_apenas_cpf">

                        <div class="row">
                            <div class="col col-12" :class="is_sus ? 'col-md-3' : 'col-md-6'">
                                <az-input
                                    type="cpf"
                                    label="CPF"
                                    required
                                    :validate="validate" 
                                    v-model="dados.cpf" />
                            </div>
                        </div>

                        <!-- Termo -->

                        <template v-if="info && info.op && info.op.termo && adicao_selecionada.st_tipo == 'T'">

                            <div class="card mt-3">
                                <div class="card-header">
                                    Termo de Consentimento
                                </div>
                                <div class="card-body">
                                    <div style="white-space: pre-wrap;">{{ info.op.termo }}</div>
                                </div>
                            </div>

                            <div class="mt-3">
                                <az-input
                                    type="checkbox-group"
                                    label="Aceito Termo de Consentimento"
                                    v-model="aceite_termo" />
                            </div>

                        </template>

                        <div class="mt-3">
                            <az-submit @click="atualizar()" :disabled="!dados.cpf">Registrar</az-submit>
                        </div>

                        <br><br><br>

                    </template>

                    <template v-else>

                        <template v-if="!adicao_selecionada || adicao_selecionada.st_prefixo_senha != 'PAC'">
                        
                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        label="Nome"
                                        ref="nome"
                                        required
                                        :validate="validate" 
                                        v-model="dados.nome" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        label="Nome Social (Opcional)"
                                        v-model="dados.nome_social" />
                                </div>
                            </div>

                        </template>

                        <!-- Outros dados do Paciente -->

                        <div class="row">
                            <div class="col col-12" :class="is_sus ? 'col-md-3' : 'col-md-6'">
                                <az-input
                                    type="cpf"
                                    label="CPF"
                                    required
                                    :validate="validate" 
                                    v-model="dados.cpf" />
                            </div>
                            <div class="col col-12 col-md-3" v-if="is_sus && 1==0">
                                <az-input
                                    label="Cartão SUS (CNS)"
                                    type="cns" 
                                    :validate="validate" 
                                    required2="adicao_selecionada.st_prefixo_senha != 'PAC'"
                                    v-model="dados.cartao_sus" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Data de Nascimento"
                                    type="date" 
                                    :required="adicao_selecionada.st_prefixo_senha != 'PAC'"
                                    :validate="validate" 
                                    :rules="['nasc']"
                                    v-model="dados.nascimento" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input 
                                    label="Sexo" 
                                    type="sexo" 
                                    :required="adicao_selecionada.st_prefixo_senha != 'PAC'"
                                    :validate="validate"
                                    v-model="dados.sexo" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    label="Celular" 
                                    type="fone" 
                                    v-model="dados.celular" 
                                    required
                                    :validate="validate" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    label="e-mail" 
                                    type="email" 
                                    v-model="dados.email" 
                                    :validate="validate" />
                            </div>
                        </div>

                        <div class="row" v-if="is_sus">
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    label="Raça" 
                                    type="select" 
                                    v-model="dados.st_raca" 
                                    :optionsList="[
                                        { id: '01', search: 'Branca' }, 
                                        { id: '02', search: 'Preta' }, 
                                        { id: '03', search: 'Parda' }, 
                                        { id: '04', search: 'Amarela' }, 
                                        { id: '05', search: 'Indígena' }, 
                                    ]"
                                    optionsData="id"
                                    :required="adicao_selecionada.st_prefixo_senha != 'PAC'"
                                    :validate="validate" />
                            </div>
                        </div>

                        <!-- Vinculo a Senha -->
                        <template v-if="informar_senha">
                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        label="Tipo de Atendimento"
                                        placeholder="Particular ou Plano de Saúde..."
                                        type="select"
                                        :optionsList="[
                                            { id: 'P', search: 'Particular' }, 
                                            { id: 'S', search: 'Plano de Saúde' },
                                        ]"
                                        optionsData="id"
                                        required
                                        :validate="validate"
                                        v-model="dados.tipo_atendimento" />
                                </div>
                            </div>
                            <div class="row" v-if="dados.tipo_atendimento == 'S'">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        v-if="info && info.op && info.op.opers"
                                        label="Plano de Saúde"
                                        placeholder="Selecionar..."
                                        type="select"
                                        :optionsList="info.op.opers"
                                        optionsData="id_operadora"
                                        required
                                        :validate="validate"
                                        v-model="dados.plano" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        label="Matrícula do Plano de Saúde"
                                        placeholder="Informar..."
                                        type="text"
                                        :validate="validate"
                                        v-model="dados.matricula" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <az-input 
                                        pattern="[0-9]*"
                                        type="number"
                                        label="Senha da Chamada" 
                                        :placeholder="'Informar apenas o número da senha...'"
                                        v-model="dados.senha_num" 
                                        required
                                        :validate="validate">
                                        <template v-slot:buttonposb v-if="senha_chamada">
                                            <div class="input-group-append">
                                                <span class="input-group-text" :class="dados.senha_num ? '' : 'text-muted'">
                                                    {{ senha_chamada }}
                                                </span>
                                            </div>
                                        </template>
                                    </az-input>
                                    <div class="small text-muted">Informar apenas o número da senha... (Ex.: 10)</div>
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input 
                                        label="Código do Atendimento" 
                                        placeholder="Informar... (Ex.: ABCDEF)..."
                                        v-model="dados.codigo_atendimento" 
                                        required
                                        :validate="validate" />
                                    <div class="small text-muted">Informar o Código do Atendimento... (Ex.: ABCDEF)...</div>
                                </div>
                            </div>
                        </template>


                        <!-- Termo -->

                        <template v-if="info && info.op && info.op.termo && adicao_selecionada.st_tipo == 'T'">

                            <div class="card mt-3">
                                <div class="card-header">
                                    Termo de Consentimento
                                </div>
                                <div class="card-body">
                                    <div style="white-space: pre-wrap;">{{ info.op.termo }}</div>
                                </div>
                            </div>

                            <div class="mt-3">
                                <az-input
                                    type="checkbox-group"
                                    label="Aceito Termo de Consentimento"
                                    v-model="aceite_termo" />
                            </div>

                        </template>

                        <div class="mt-3">
                            <az-submit @click="atualizar()">Registrar</az-submit>
                        </div>

                        <br><br><br>

                    </template>

                </template>
                
            </template>

        </template>

        <Toast />

    </div>
</template>

<script>
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzLoading from '../../util/AzLoading.vue';

export default {
    data() { 
        return { 
            dados: { 
                nome: "",
                nome_social: "", 
                cpf: "", 
                nascimento: "", 
                sexo: "", 
                celular: "", 
                email: "", 
                tipo_atendimento: "",
                plano: "",  
                matricula: "", 
            },

            info: null,

            validate: false, 

            pronto: false, 
            msg: "", 

            sel_adicao: null, 
            loading: false, 

            retorno: null, 
            aceite_termo: false, 

            informar_senha: false, 
            informar_apenas_cpf: false, 
        }
    },

    components: { 
        AzInput, 
        AzSubmit,
        AzLoading, 
    },

    props: ['id_recepcao', 'id_adicao'],
    
    computed: { 
        senha_chamada: function () { 
            if ( this.adicao_selecionada.st_prefixo_senha ) { 
                if ( this.dados.senha_num ) { 
                    return this.adicao_selecionada.st_prefixo_senha + ( this.dados.senha_num ? this.dados.senha_num.toString().padStart(4, '0') : '' );
                }
            } 

            return '';
        },

        is_sus: function () { 
            if ( !this.sel_adicao )
                return false;

            if ( !this.info || !this.info.r || !this.info.r.adicoes ) 
                return false; 

            return _.get(
                this.info.r.adicoes.find(ad => ad.id_recepcao_adicao == this.sel_adicao),
                'plano.operadora.fl_sus'
            );
        },

        adicao_selecionada: function () { 
            if ( !this.sel_adicao )
                return null;

            if ( !this.info || !this.info.r || !this.info.r.adicoes ) 
                return null; 

            return this.info.r.adicoes.find(ad => ad.id_recepcao_adicao == this.sel_adicao);
        }
    },

    methods: { 
        selecionar_adicao(adicao) { 

            this.sel_adicao = ( this.sel_adicao == adicao.id_recepcao_adicao ? null : adicao.id_recepcao_adicao );

            if ( this.sel_adicao ) { 
                this.$nextTick(() => { 
                    if ( this.$refs['nome'] ) { 
                        this.$refs['nome'].$refs.input.focus();
                    }
                });
            }

        },

        atualizar () { 

            if ( this.info && this.info.op && this.info.op.termo && this.adicao_selecionada.st_tipo == 'T' && !this.aceite_termo ) { 
                this.$toast.add({ 
                    severity: "error",
                    summary: "Atenção",
                    detail: "Para registrar, é necessário o aceite ao termo de consentimento.",
                    life: 3000
                });
                return;
            }

            this.validate = true; 
            this.loading = true; 

            this.dados.senha_chamada = this.senha_chamada;
            
            let dados = { 
                ...this.dados, 
                id_recepcao_adicao: this.sel_adicao, 
                is_sus: this.is_sus, 
            };

            if ( this.informar_apenas_cpf ) { 
                dados.porcpf = true; 
            }

            this.$store.commit('loading', true);

            this.axios.post('/' + window.redir + '/novocadastro', dados, {
                    headers: {
                        "X-DOMAIN": window.redir, 
                        "Content-Type": "application/json"
                    }
                })
                .then(res => { 
                    this.retorno = res;

                    if ( res.data.link ) {
                        let link = res.data.link;
                        link = link.replace('videochamada', 'preatendimento');
                        
                        window.location = link + ( this.informar_senha ? ( link.indexOf('?') > 0 ? '&' : '?' ) + 'c=1&b=2' : '' );
                        return;
                    }
                })
                .finally(() => { 
                    this.loading = false;
                    this.$store.commit('loading', false);
                });

        },

    },

    mounted() { 
        if ( !this.id_recepcao || isNaN(this.id_recepcao) ) { 
            this.msg = "Link inválido.";
            this.pronto = true;

            return;
        }

        if ( this.$route.query.s ) { 
            this.informar_senha = true; 
        } else if ( this.$route.query.cp ) { 
            this.informar_apenas_cpf = true; 
        }

        this.axios.get("/subdomain?l=1&r=" + this.id_recepcao, {
                headers: {
                    "X-DOMAIN": window.redir, 
                    "Content-Type": "application/json"
                }
            })
            .then(res => {

                if ( !res.data.r || !res.data.r.adicoes || !res.data.r.adicoes.length ) { 
                    this.msg = "Link inválido!";
                    return;
                }

                res.data.r.adicoes = res.data.r.adicoes.filter(ad => ( ad.st_tipo == 'A' || ad.st_tipo == 'T' ) && ad.st_prefixo_senha != 'ADD'
                    && ( !this.id_adicao || ad.id_recepcao_adicao == this.id_adicao ) );

                if ( res.data.r.adicoes.length == 1 ) { 
                    this.sel_adicao = res.data.r.adicoes[0].id_recepcao_adicao;
                }

                this.info = res.data; 
            })
            .finally(() => { 
                this.pronto = true;

                this.$nextTick(() => { 
                    if ( this.$refs['nome'] ) { 
                        this.$refs['nome'].$refs.input.focus();
                    }
                });
            });
            
    }


}
</script>
